"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Fitxer: index.ts
 * Autor: Jordi Riu Amblàs
 * Data: 31/07/2019
 * (c) Ajuntament de Manresa - jul 2019 - Departament de Sistemes d'Informació
 */

var DataGrid_1 = require("./DataGrid");

var DataGridField_1 = require("./DataGridField");

exports.DataGridField = DataGridField_1.default;
exports.default = DataGrid_1.default;